import { TSearch, TSearchContext } from "@components/types";
import appConfig from "@core/appconfig";
import { getLocation } from "@core/geolocation";
import { handleResponse } from ".";
import client from "./gql";

export const getSearch = async (
    query: string,
    intent: string,
    context: TSearchContext = {}
) => {
    return getSearchsuggest({
        descriptor: { q: query, intent: intent },
        context: context,
    });
};

export const getSearchsuggest = async (search: TSearch) => {
    let location = await getLocation();
    let accountid = appConfig?.accountId;
    const hasValidLocation = location?.latitude !== null && location?.latitude !== undefined &&
        location?.longitude !== null && location?.longitude !== undefined;

    const locationParams = hasValidLocation
        ? `lat:${location?.latitude}, lon:${location?.longitude}`
        : '';

    // JSON.stringify yields a valid, escaped GraphQL string literal (quotes and backslashes included).
    const term = JSON.stringify(search.descriptor.q ?? '');
    const query = `
      query MyQuery {
        get_productcategories(name:${term}) {
            id
            name
        }
        get_stores(name:${term}${hasValidLocation ? ', ' + locationParams : ''} ${accountid > 0 ? ', account_id: ' + accountid : ''}) {
            id
            name
            category_id
            sub_category_id
            address {
                city { name }
                state { name }
            }
        }
        get_products(name:${term}) {
            id
            name
            category_id
        }
        get_unique_products(name:${term}${hasValidLocation ? ', ' + locationParams : ''}) {
            name
            matches
        }
        get_brands(name:${term}) {
            id
            name
        }
      }
    `;

    const result = await client.query(query, {});
    return handleResponse(null)(result);
};
